import { render } from "./PostInfo.vue?vue&type=template&id=7f0108a5"
import script from "./PostInfo.vue?vue&type=script&lang=js"
export * from "./PostInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__